<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="50%" style="z-index: 1021;">
      <v-skeleton-loader
        v-if="loading"
        type="article, actions"
      ></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title>
          <v-panel>
            <span style="font-size: 20px">
              {{ !data.id ? $t("wkt.admin.workplace.edit-holidays-window.vacation-dialog.create_holiday_title") : $t("wkt.admin.workplace.edit-holidays-window.vacation-dialog.edit_holiday_title") }}
            </span>
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="4">
                  <v-menu
                    ref="dateMenu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted"
                        :label="$t('wkt.admin.workplace.edit-holidays-window.vacation-dialog.date')"
                        v-on="on"
                        v-bind="attrs"
                        @blur="date =formatLocalDateToISOStringDate(dateFormatted)"
                        :rules="[validationRules.required]"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      :first-day-of-week="1"
                      :locale="$i18n.locale"
                      no-title
                      @input="updateFormattedDate()"
                      @change="dateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="data.dayType"
                    :items="dayTypes"
                    item-text="name"
                    item-value="id"
                    menu-props="bottom, offsetY"
                    :label="$t('wkt.admin.workplace.edit-holidays-window.vacation-dialog.type')"
                  />
                </v-col>
                <v-col cols="4">      
                  <v-switch
                    :label="$t('wkt.admin.workplace.edit-holidays-window.vacation-dialog.checkin_allowed')"
                    v-model="data.checkinAllowed">
                  </v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="data.description"
                    :label="$t('wkt.admin.workplace.edit-holidays-window.vacation-dialog.description')"
                    autocomplete="none"
                    max="400"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
            <v-icon left color="#ffffff">delete</v-icon>
            <span style="color: #ffffff">{{ $t("wkt.admin.common.dialog-buttons.delete").toUpperCase() }}</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#185EA9"
            text
            @click="onSave()"
            style="font-size: 0.9em; font-weight: 400"
            >{{ $t("wkt.admin.common.dialog-buttons.ok").toUpperCase() }}</v-btn
          >
          <v-btn
            text
            @click="cancelEdit()"
            style="font-size: 0.9em; font-weight: 400"
            >{{
              $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase()
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog
      style="z-index: 1023;"
      ref="dlgConfirm"
      :title="$t('wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.confirm-delete.title')"
      :message="$t('wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.confirm-delete.text')"
      :titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
      :titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
      @confirmed="deleteItem()" />
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ConfirmDialog from "../../common/ConfirmDialog";
import api from "../../../api/worktime";

export default {
  name: "HolidaysDialog",
  mixins: [BaseModule],
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      payload: null,
      data: {
        dayType: 3,
      },
      date: new Date().toISOString().substr(0, 10), 
      dateFormatted: null,
      dateMenu: false,
      dayTypes: [
        { id: 1, name: this.$t("wkt.admin.elements.workday-element.holiday-type-day.rest") },
        { id: 2, name: this.$t("wkt.admin.elements.workday-element.holiday-type-day.national") },
        { id: 3, name: this.$t("wkt.admin.elements.workday-element.holiday-type-day.local") },
        { id: 4,name: this.$t("wkt.admin.elements.workday-element.holiday-type-day.company") },
      ],
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    open(workplaceId, companyId, data) {
      this.showDialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      this.data = { ...data,
        companyId,
        workplaceId,
        dayType: data?.dayType || 3,
        checkinAllowed: data?.checkinAllowed
      };
      
      if (data?.date) {
        this.loadDate(this.convertSimpleDateToDate(this.data.date));
      } else {
        // Configurar fecha actual por defecto
        const currentDate = new Date();
        currentDate.setHours(12, 0, 0);
        this.date = currentDate.toISOString().substr(0, 10);
        this.dateFormatted = this.formatISOStringDateToLocalDate(this.date);
      }
    },
    onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }
 
      this.data.date = this.convertDateToSimpleDate(new Date(`${this.date}`));

      this.loading = true;

      api.storeWorkplaceHoliday(this.data,
        () => {
          this.loading = false;
          this.showDialog = false;
          this.$emit('update-data');
        },
        (error) => {
          this.loading = false;
          this.showDialog = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
        }
      );
    },
    confirmDelete() {
      this.$refs.dlgConfirm.confirm(this.data);
    },
    deleteItem() {
      const workplaceId = this.data.workplaceId;

      this.loading = true;
      api.deleteWorkplaceHoliday(
        this.data.id,
        () => {
          api.getWorkplaceHolidays(workplaceId, res => {
            this.$emit('update-data', res);
            this.loading = false;
            this.showDialog = false;
          }, error => {
            this.loading = false;
            this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
          });
        },
        (error) => {
          this.loading = false;
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
        }
      );
    },
    updateFormattedDate() {
      if (this.date) {
        this.dateFormatted = this.formatISOStringDateToLocalDate(this.date);
      }
    },
    loadDate(date) {
      const isEmpty = date ? false : true;

      if (!date) {
        date = new Date();
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);
      }// else {
        date = this.formatLongDateTime(date);
      //}

      if (!isEmpty) {
        this.date = this.formatLocalDateToISOStringDate(date.split(', ')[0]);
        this.dateFormatted = this.formatISOStringDateToLocalDate(this.date);
      } else {        
        this.date = null;
        this.dateFormatted = null;
      }
    },
    resetDialog() {
      this.data = {};
      this.date = null;
      this.dateFormatted = null;
      this.dateMenu = false;
    },
    cancelEdit() {
      this.showDialog = false;
      this.resetDialog();
    }
  },
  watch: {
    date() {
      this.updateFormattedDate();
    }
  }
};
</script>
